import React from "react";
import { createPortal } from "react-dom";

const DeleteConfirmPopUp = ({
  isConfirmDeleteOpen,
  setIsConfirmDeleteOpen,
  handleDelete,
  title = "Delete item",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
}) => {
  if (!isConfirmDeleteOpen) return null;

  const onCancel = () => {
    setIsConfirmDeleteOpen(false);
  };

  const onConfirm = (e) => {
    if (handleDelete) {
      handleDelete(e);
    }
  };

  return createPortal(
    <div className="ct-confirm-overlay" role="dialog" aria-modal="true">
      <div className="ct-confirm-modal">
        <div className="ct-confirm-header">
          <h3 className="ct-confirm-title">{title}</h3>
        </div>
        <div className="ct-confirm-body">
          <p className="ct-confirm-message">{message}</p>
        </div>
        <div className="ct-confirm-footer">
          {cancelLabel && (
            <button
              type="button"
              className="ct-btn ct-btn-secondary"
              onClick={onCancel}
            >
              {cancelLabel}
            </button>
          )}
          <button
            type="button"
            className="ct-btn ct-btn-danger"
            onClick={(e) => onConfirm(e)}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DeleteConfirmPopUp;
